function cartQNA() {
  $('.jsCartQuestion').click(function(){
    var $answer = $(this).next('.jsCartAnswer');

    $('.jsCartAnswer').fadeOut();
    $answer.fadeIn();
  });

  $(document).click(function(e){
    var container = $('.jsCartQuestion');
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
       $('.jsCartAnswer').fadeOut();
    }
  });
}

function updateCartSummary() {
  var newSubtotal = $('#jsCartHidden-subtotal').val();
  var newTotal = $('#jsCartHidden-total').val();
  var newCount = Number($('#jsCartHidden-count').val());
  var txtCount = ' item';

  if (newCount > 1) { txtCount = ' items'}

  $('.jsCartSummary-count').text(newCount + txtCount);
  $('.jsCartSummary-subtotal').text('$' + newSubtotal);
  $('.jsCartSummary-total').text('$' + newTotal);
}

function updateCartItems(stringUpdate) {
  $.post(window.Shopify.routes.root + 'cart/update.js', stringUpdate);
  setTimeout(function(){
    $.get('/cart').done(function(data){
      var newContent = $(data).find('#jsCartList').contents();
      $('#jsCartList').empty().append(newContent);
      updateCartSummary();
    });
  }, 500);
}

function showCartItemError($parent, qty, maxqty) {
  var msg = '<div class="ci-error warning">Only quantity of ' + maxqty + ' can be added to cart.</div>';

  $parent.append(msg);
}

function updateItemQty() {
  $('html').on('click', '.jsCartItem-update', function(){
    var $parent = $(this).parents('.jsCartItem');
    var $input = $parent.find('.jsCartItem-qty');
    var pid = Number($parent.data('product-id'));
    var qty = Number($input.val());
    var maxqty = Number($input.data('max'));

    var stringUpdate = 'updates[' + pid + ']=' + qty;

    if(qty > maxqty) {
      showCartItemError($parent, qty, maxqty);
    } else {
      updateCartItems(stringUpdate);
    }
  });
}

function removeItem(){
  $('html').on('click', '.jsCartItem-remove', function(){
    var removeUrl = $(this).data('url');
    var $parent = $(this).parents('.jsCartItem');
    var productTitle = $parent.find('.jsCartItem-title').text();
    var productLink = $parent.find('.jsCartItem-title').prop('href');
            
    var msg = '<div class="cartItem reconsider warning"><strong>'+ productTitle +'</strong> has been removed from cart. <a href="'+ productLink +'">Reconsider</a></div>';

    $.get(removeUrl).done(function(data){
      var newContent = $(data).find('#jsCartList').contents();
      $('#jsCartList').empty().append(newContent);
      updateCartSummary();

      $('#jsCartList form').append(msg);      
    });
  });
}

$(function(){
  'use strict';

  cartQNA();
  updateItemQty();
  removeItem();

  $('.jsCarouselProduct').each(function(){
    var $productList = $(this).find('.jsCarouselProducts-track');
    var $prevBtn = $(this).find('.jsCarouselProduct-prev');
    var $nextBtn = $(this).find('.jsCarouselProduct-next');

    $productList.slick({
      slidesToShow: 4,
      slidesToScroll: 2,
      nextArrow: $nextBtn,
      prevArrow: $prevBtn,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        }
      ]
    });
  });

  
});